import React from "react";
import {
    Box,
    Typography,
    Stack,
    Paper,
    IconButton,
    CircularProgress,
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";

const CommentAttachments = ({ comment }) => {
    // const { data, isLoading, isError } = useGetRiskAttachmentsByCommentQuery(
    //     comment.projectRiskCommentId, {
    //     skip: !comment?.projectRiskCommentId,
    // });

   
    const attachments =  [];

    // if (isLoading)
    //     return (
    //         <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
    //             <CircularProgress size={20} sx={{ mr: 1 }} />{" "}
    //             <Typography variant="caption">Loading attachments...</Typography>
    //         </Box>
    //     );

   
    // if (isError || !attachments.length) return null;

    return (
        <Box sx={{ mt: 1.5 }}>
            <Typography
                variant="caption"
                sx={{ color: "text.secondary", mb: 0.5, display: "block" }}
            >
                Attachments:
            </Typography>
            <Stack spacing={1}>
                {attachments.map((file, i) => (
                    <Paper
                        key={file.fileId || i}
                        variant="outlined"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            p: 1,
                            pl: 1.5,
                            borderRadius: 1,
                            borderColor: "#ddd",
                            bgcolor: "#fff",
                        }}
                    >
                        <Stack direction="row" spacing={1} alignItems="center">
                            <AttachmentIcon fontSize="small" color="action" />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "#1976d2",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                }}
                            >
                                {file.fileName}
                            </Typography>
                        </Stack>
                        <IconButton size="small">
                            <DownloadIcon fontSize="small" />
                        </IconButton>
                    </Paper>
                ))}
            </Stack>
        </Box>
    );
};

export default CommentAttachments;